import { PinLevelPermissionCheckboxList } from "./PinLevelPermissionCheckboxList";

export default PinLevelPermissionCheckboxList;
